import { emptyGraphqlApi } from '../emptyApi';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Cursor: { input: any; output: any; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Duration: { input: string; output: string; }
  LocalTime: { input: string; output: string; }
  TimeZone: { input: string; output: string; }
};

export type Accessory = {
  account?: Maybe<Account>;
  createdAt: Scalars['DateTime']['output'];
  disabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  monitor?: Maybe<Monitor>;
  nickname?: Maybe<Scalars['String']['output']>;
  operationStatus: AccessoryOperationalStatus | '%future added value';
  operational: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  operationalStatus: AccessoryOperationalStatus | '%future added value';
  parentAccessory?: Maybe<Accessory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AccessoryConnection = {
  __typename?: 'AccessoryConnection';
  edges: Array<AccessoryEdge>;
  nodes: Array<Accessory>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AccessoryEdge = {
  __typename?: 'AccessoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Accessory>;
};

export enum AccessoryEventType {
  BatteryLow = 'BATTERY_LOW',
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type AccessoryEventsSubscriptionInput = {
  accountId: Scalars['ID']['input'];
};

export enum AccessoryGesture {
  DoublePress = 'DOUBLE_PRESS',
  LongPress = 'LONG_PRESS',
  SinglePress = 'SINGLE_PRESS',
  TriplePress = 'TRIPLE_PRESS'
}

export type AccessoryGestureAction = {
  __typename?: 'AccessoryGestureAction';
  action?: Maybe<Scalars['String']['output']>;
  gesture: AccessoryGesture | '%future added value';
};

export enum AccessoryOperationalStatus {
  Disabled = 'DISABLED',
  Offline = 'OFFLINE',
  Operational = 'OPERATIONAL',
  Unknown = 'UNKNOWN'
}

export type Account = {
  __typename?: 'Account';
  accessories: AccessoryConnection;
  beacons: BeaconConnection;
  climates: ClimateConnection;
  dashboard?: Maybe<DashboardAccount>;
  devices: DeviceConnection;
  features: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  monitors: MonitorConnection;
  name?: Maybe<Scalars['String']['output']>;
  staffList: StaffListConnection;
  staffProfiles: StaffProfileConnection;
  statisticsDimensions: Array<Maybe<StatisticsDimension>>;
  viewerPermissions: AccountViewerPermissions;
};


export type AccountAccessoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccountBeaconsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccountDevicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccountMonitorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccountStaffListArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountStaffProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountStatisticsDimensionsArgs = {
  climateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dimensions?: InputMaybe<Array<StatisticsDimensionInput>>;
  measure: Scalars['String']['input'];
  monitorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  soundSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountStatusUpdatesSubscriptionAccessoryPayload = AccountStatusUpdatesSubscriptionPayload & {
  __typename?: 'AccountStatusUpdatesSubscriptionAccessoryPayload';
  accessoryId: Scalars['ID']['output'];
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  disabled: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  monitorId?: Maybe<Scalars['ID']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  online?: Maybe<Scalars['Boolean']['output']>;
  operationStatus: AccessoryOperationalStatus | '%future added value';
  operational: Scalars['Boolean']['output'];
  parentAccessoryId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AccountStatusUpdatesSubscriptionClimateAlarmPayload = AccountStatusUpdatesSubscriptionPayload & {
  __typename?: 'AccountStatusUpdatesSubscriptionClimateAlarmPayload';
  accountId: Scalars['ID']['output'];
  climateAlarmId: Scalars['ID']['output'];
  climateId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentStatus: ClimateAlarmCurrentStatus | '%future added value';
  metric: ClimateAlarmMetric | '%future added value';
  thresholdType: ClimateAlarmThresholdType | '%future added value';
  updatedAt: Scalars['DateTime']['output'];
};

export type AccountStatusUpdatesSubscriptionClimatePayload = AccountStatusUpdatesSubscriptionPayload & {
  __typename?: 'AccountStatusUpdatesSubscriptionClimatePayload';
  accessoryId?: Maybe<Scalars['ID']['output']>;
  accountId: Scalars['ID']['output'];
  climateId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  humidity?: Maybe<Scalars['Float']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  monitorId?: Maybe<Scalars['ID']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AccountStatusUpdatesSubscriptionInput = {
  accountId: Scalars['ID']['input'];
  statusUpdateTypes?: InputMaybe<Array<AccountStatusUpdatesType | '%future added value'>>;
};

export type AccountStatusUpdatesSubscriptionMonitorPayload = AccountStatusUpdatesSubscriptionPayload & {
  __typename?: 'AccountStatusUpdatesSubscriptionMonitorPayload';
  accountId: Scalars['ID']['output'];
  charging?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  monitorId: Scalars['ID']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  online?: Maybe<Scalars['Boolean']['output']>;
  operationStatus: MonitorOperationalStatus | '%future added value';
  operational: Scalars['Boolean']['output'];
  power?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AccountStatusUpdatesSubscriptionPayload = {
  accountId: Scalars['ID']['output'];
};

export enum AccountStatusUpdatesType {
  AccessoryStatus = 'ACCESSORY_STATUS',
  ClimateAlarmStatus = 'CLIMATE_ALARM_STATUS',
  ClimateStatus = 'CLIMATE_STATUS',
  MonitorStatus = 'MONITOR_STATUS'
}

export type AccountViewerPermissions = {
  __typename?: 'AccountViewerPermissions';
  canCreateStaff: Scalars['Boolean']['output'];
};

export type AidCall = Call & {
  __typename?: 'AidCall';
  accessory?: Maybe<Accessory>;
  account?: Maybe<Account>;
  createdAt: Scalars['DateTime']['output'];
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  monitor?: Maybe<Monitor>;
  startAt: Scalars['DateTime']['output'];
  status: CallStatus | '%future added value';
  updatedAt: Scalars['DateTime']['output'];
};

export enum AttendanceStatus {
  Attended = 'ATTENDED',
  Attending = 'ATTENDING',
  NotAttended = 'NOT_ATTENDED'
}

export type Beacon = {
  __typename?: 'Beacon';
  account?: Maybe<Account>;
  major: Scalars['Int']['output'];
  minor: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type BeaconConnection = {
  __typename?: 'BeaconConnection';
  edges: Array<BeaconEdge>;
  nodes: Array<Beacon>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BeaconEdge = {
  __typename?: 'BeaconEdge';
  cursor: Scalars['Cursor']['output'];
  node: Beacon;
};

export type BridgeAccessory = Accessory & Node & {
  __typename?: 'BridgeAccessory';
  account?: Maybe<Account>;
  createdAt: Scalars['DateTime']['output'];
  disabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  monitor?: Maybe<Monitor>;
  nickname?: Maybe<Scalars['String']['output']>;
  operationStatus: AccessoryOperationalStatus | '%future added value';
  operational: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  operationalStatus: AccessoryOperationalStatus | '%future added value';
  parentAccessory?: Maybe<Accessory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ButtonAccessory = Accessory & Node & {
  __typename?: 'ButtonAccessory';
  account?: Maybe<Account>;
  createdAt: Scalars['DateTime']['output'];
  disabled: Scalars['Boolean']['output'];
  gestureActions: Array<AccessoryGestureAction>;
  id: Scalars['ID']['output'];
  latestCall?: Maybe<Call>;
  location?: Maybe<Location>;
  monitor?: Maybe<Monitor>;
  nickname?: Maybe<Scalars['String']['output']>;
  operationStatus: AccessoryOperationalStatus | '%future added value';
  operational: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  operationalStatus: AccessoryOperationalStatus | '%future added value';
  parentAccessory?: Maybe<Accessory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Call = {
  accessory?: Maybe<Accessory>;
  account?: Maybe<Account>;
  createdAt: Scalars['DateTime']['output'];
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  monitor?: Maybe<Monitor>;
  startAt: Scalars['DateTime']['output'];
  status: CallStatus | '%future added value';
  updatedAt: Scalars['DateTime']['output'];
};

export enum CallStatus {
  Attended = 'ATTENDED',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Expired = 'EXPIRED',
  Missed = 'MISSED',
  NotAttended = 'NOT_ATTENDED'
}

export type Climate = Node & {
  __typename?: 'Climate';
  accessory?: Maybe<Accessory>;
  account?: Maybe<Account>;
  alarms: Array<ClimateAlarm>;
  createdAt: Scalars['DateTime']['output'];
  humidity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  monitor?: Maybe<Monitor>;
  temperature?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ClimateAlarm = {
  __typename?: 'ClimateAlarm';
  alarmThreshold: Scalars['Float']['output'];
  climate: Climate;
  createdAt: Scalars['DateTime']['output'];
  currentStatus: ClimateAlarmCurrentStatus | '%future added value';
  disabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  metric: ClimateAlarmMetric | '%future added value';
  recoverThreshold?: Maybe<Scalars['Float']['output']>;
  thresholdType: ClimateAlarmThresholdType | '%future added value';
  updatedAt: Scalars['DateTime']['output'];
};

export enum ClimateAlarmCurrentStatus {
  Alarm = 'ALARM',
  NoData = 'NO_DATA',
  Ok = 'OK',
  Recover = 'RECOVER'
}

export enum ClimateAlarmMetric {
  Humidity = 'HUMIDITY',
  Temperature = 'TEMPERATURE'
}

export enum ClimateAlarmThresholdType {
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL'
}

export type ClimateConnection = {
  __typename?: 'ClimateConnection';
  nodes: Array<Climate>;
};

export type ClimateSensorAccessory = Accessory & Node & {
  __typename?: 'ClimateSensorAccessory';
  account?: Maybe<Account>;
  climate?: Maybe<Climate>;
  createdAt: Scalars['DateTime']['output'];
  disabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  monitor?: Maybe<Monitor>;
  nickname?: Maybe<Scalars['String']['output']>;
  operationStatus: AccessoryOperationalStatus | '%future added value';
  operational: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  operationalStatus: AccessoryOperationalStatus | '%future added value';
  parentAccessory?: Maybe<Accessory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CreateStaffInput = {
  name: Scalars['String']['input'];
};

export type CreateStaffPayload = {
  __typename?: 'CreateStaffPayload';
  staff: Staff;
};

export type DashboardAccount = {
  __typename?: 'DashboardAccount';
  averageResponseTime?: Maybe<Scalars['Duration']['output']>;
  connectedDevicesCount: Scalars['Int']['output'];
  kanban?: Maybe<DashboardKanban>;
  operationalMonitorsCount: Scalars['Int']['output'];
  responseCount: Scalars['Int']['output'];
};

export type DashboardKanban = {
  __typename?: 'DashboardKanban';
  events: Array<DashboardKanbanEvent>;
};

export type DashboardKanbanAttendanceEvent = {
  __typename?: 'DashboardKanbanAttendanceEvent';
  attendanceStatus: AttendanceStatus | '%future added value';
  createdAt: Scalars['DateTime']['output'];
  isPhysicalAttendance: Scalars['Boolean']['output'];
  monitor?: Maybe<Monitor>;
};

export type DashboardKanbanCallEvent = {
  __typename?: 'DashboardKanbanCallEvent';
  attendanceStatus: AttendanceStatus | '%future added value';
  createdAt: Scalars['DateTime']['output'];
  monitor?: Maybe<Monitor>;
};

export type DashboardKanbanEvent = DashboardKanbanAttendanceEvent | DashboardKanbanCallEvent | DashboardKanbanSoundEvent;

export type DashboardKanbanSoundEvent = {
  __typename?: 'DashboardKanbanSoundEvent';
  attendanceStatus: AttendanceStatus | '%future added value';
  createdAt: Scalars['DateTime']['output'];
  monitor?: Maybe<Monitor>;
  notificationImportance?: Maybe<NotificationImportance | '%future added value'>;
  sound?: Maybe<Sound>;
};

export type DeleteStaffInput = {
  id: Scalars['ID']['input'];
};

export type DeleteStaffPayload = {
  __typename?: 'DeleteStaffPayload';
  id: Scalars['ID']['output'];
};

export type Device = Node & {
  __typename?: 'Device';
  account?: Maybe<Account>;
  activeCheckout?: Maybe<DeviceCheckout>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DeviceCheckout = {
  __typename?: 'DeviceCheckout';
  createdAt: Scalars['DateTime']['output'];
  device: Device;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  staff?: Maybe<Staff>;
  staffProfile: StaffProfile;
  startAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DeviceConnection = {
  __typename?: 'DeviceConnection';
  edges: Array<DeviceEdge>;
  nodes: Array<Device>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DeviceEdge = {
  __typename?: 'DeviceEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Device>;
};

export type EndDeviceCheckoutInput = {
  deviceId: Scalars['ID']['input'];
};

export type EndDeviceCheckoutPayload = {
  __typename?: 'EndDeviceCheckoutPayload';
  device: Device;
  deviceCheckout?: Maybe<DeviceCheckout>;
};

export type GenericAccessory = Accessory & Node & {
  __typename?: 'GenericAccessory';
  account?: Maybe<Account>;
  createdAt: Scalars['DateTime']['output'];
  disabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  monitor?: Maybe<Monitor>;
  nickname?: Maybe<Scalars['String']['output']>;
  operationStatus: AccessoryOperationalStatus | '%future added value';
  operational: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  operationalStatus: AccessoryOperationalStatus | '%future added value';
  parentAccessory?: Maybe<Accessory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GenericCall = Call & {
  __typename?: 'GenericCall';
  accessory?: Maybe<Accessory>;
  account?: Maybe<Account>;
  createdAt: Scalars['DateTime']['output'];
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  monitor?: Maybe<Monitor>;
  startAt: Scalars['DateTime']['output'];
  status: CallStatus | '%future added value';
  updatedAt: Scalars['DateTime']['output'];
};

export type Location = {
  __typename?: 'Location';
  account?: Maybe<Account>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locationType: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Monitor = Node & {
  __typename?: 'Monitor';
  account?: Maybe<Account>;
  charging?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deactivated: Scalars['Boolean']['output'];
  disabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  nickname?: Maybe<Scalars['String']['output']>;
  online?: Maybe<Scalars['Boolean']['output']>;
  operationStatus: MonitorOperationalStatus | '%future added value';
  operational: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  operationalStatus: MonitorOperationalStatus | '%future added value';
  power?: Maybe<Scalars['Boolean']['output']>;
  recentObservations: Array<Observation>;
  routines: Array<MonitorRoutine>;
  selectedSounds: Array<Sound>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MonitorConnection = {
  __typename?: 'MonitorConnection';
  edges: Array<MonitorEdge>;
  nodes: Array<Monitor>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MonitorEdge = {
  __typename?: 'MonitorEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Monitor>;
};

export enum MonitorEventType {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Plugged = 'PLUGGED',
  PoweredOff = 'POWERED_OFF',
  PoweredOn = 'POWERED_ON',
  Unplugged = 'UNPLUGGED'
}

export type MonitorEventsSubscriptionInput = {
  accountId: Scalars['ID']['input'];
};

export enum MonitorOperationalStatus {
  Deactivated = 'DEACTIVATED',
  Disabled = 'DISABLED',
  Offline = 'OFFLINE',
  Operational = 'OPERATIONAL',
  PoweredOff = 'POWERED_OFF',
  Unknown = 'UNKNOWN'
}

export type MonitorRoutine = {
  __typename?: 'MonitorRoutine';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  endTime: Scalars['LocalTime']['output'];
  id: Scalars['ID']['output'];
  startTime: Scalars['LocalTime']['output'];
  timeZone: Scalars['TimeZone']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createStaff: CreateStaffPayload;
  deleteStaff: DeleteStaffPayload;
  endDeviceCheckout: EndDeviceCheckoutPayload;
  savePresence: SavePresencePayload;
  startDeviceCheckout: StartDeviceCheckoutPayload;
  updateStaff: UpdateStaffPayload;
  updateStaffProfile: UpdateStaffProfilePayload;
};


export type MutationCreateStaffArgs = {
  input: CreateStaffInput;
};


export type MutationDeleteStaffArgs = {
  input: DeleteStaffInput;
};


export type MutationEndDeviceCheckoutArgs = {
  input: EndDeviceCheckoutInput;
};


export type MutationSavePresenceArgs = {
  input: SavePresenceInput;
};


export type MutationStartDeviceCheckoutArgs = {
  input: StartDeviceCheckoutInput;
};


export type MutationUpdateStaffArgs = {
  input: UpdateStaffInput;
};


export type MutationUpdateStaffProfileArgs = {
  input: UpdateStaffProfileInput;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export enum NotificationImportance {
  Default = 'DEFAULT',
  High = 'HIGH',
  Low = 'LOW'
}

export type Observation = {
  __typename?: 'Observation';
  account?: Maybe<Account>;
  createdAt: Scalars['DateTime']['output'];
  monitor?: Maybe<Monitor>;
  observationType: Scalars['String']['output'];
  sound?: Maybe<Sound>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ObservationConnection = {
  __typename?: 'ObservationConnection';
  nodes: Array<Observation>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type Person = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<PersonProfile>;
  updatedAt: Scalars['DateTime']['output'];
  viewerCanDelete: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
};

export type PersonProfile = {
  createdAt: Scalars['DateTime']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person?: Maybe<Person>;
  updatedAt: Scalars['DateTime']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
};

export type Presence = Node & {
  __typename?: 'Presence';
  account?: Maybe<Account>;
  clientRef?: Maybe<Scalars['String']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  monitor?: Maybe<Monitor>;
  startAt: Scalars['DateTime']['output'];
};

export type Query = {
  __typename?: 'Query';
  accessories: AccessoryConnection;
  /** @deprecated No longer supported */
  accessory?: Maybe<Accessory>;
  account?: Maybe<Account>;
  beacon?: Maybe<Beacon>;
  beacons: BeaconConnection;
  call?: Maybe<Call>;
  /** @deprecated No longer supported */
  climate?: Maybe<Climate>;
  currentAccount?: Maybe<Account>;
  currentDevice?: Maybe<Device>;
  monitor?: Maybe<Monitor>;
  monitors: MonitorConnection;
  node?: Maybe<Node>;
  nodes: Array<Maybe<Node>>;
  sound?: Maybe<Sound>;
  soundBySlug?: Maybe<Sound>;
  sounds: SoundConnection;
};


export type QueryAccessoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAccessoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBeaconArgs = {
  major: Scalars['Int']['input'];
  minor: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};


export type QueryBeaconsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCallArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClimateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMonitorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMonitorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QuerySoundArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySoundBySlugArgs = {
  slug: Scalars['String']['input'];
};

export type Resident = Person & {
  __typename?: 'Resident';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<PersonProfile>;
  updatedAt: Scalars['DateTime']['output'];
  viewerCanDelete: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
};

export type ResidentProfile = PersonProfile & {
  __typename?: 'ResidentProfile';
  createdAt: Scalars['DateTime']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person?: Maybe<Person>;
  updatedAt: Scalars['DateTime']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
};

export type SavePresenceInput = {
  beaconMajor: Scalars['Int']['input'];
  beaconMinor: Scalars['Int']['input'];
  beaconUuid: Scalars['String']['input'];
  clientRef?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt: Scalars['DateTime']['input'];
};

export type SavePresencePayload = {
  __typename?: 'SavePresencePayload';
  presence?: Maybe<Presence>;
};

export type Sound = Node & {
  __typename?: 'Sound';
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type SoundIconUrlArgs = {
  fileType: SoundIconFileType;
};

export type SoundConnection = {
  __typename?: 'SoundConnection';
  nodes: Array<Sound>;
};

export enum SoundIconFileType {
  Png = 'PNG',
  Svg = 'SVG'
}

export type Staff = Person & {
  __typename?: 'Staff';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<PersonProfile>;
  updatedAt: Scalars['DateTime']['output'];
  viewerCanDelete: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
};

export type StaffEdge = {
  __typename?: 'StaffEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Staff>;
};

export type StaffListConnection = {
  __typename?: 'StaffListConnection';
  edges: Array<StaffEdge>;
  nodes: Array<Staff>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StaffProfile = PersonProfile & {
  __typename?: 'StaffProfile';
  createdAt: Scalars['DateTime']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person?: Maybe<Person>;
  updatedAt: Scalars['DateTime']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
};

export type StaffProfileConnection = {
  __typename?: 'StaffProfileConnection';
  edges: Array<StaffProfileEdge>;
  nodes: Array<StaffProfile>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StaffProfileEdge = {
  __typename?: 'StaffProfileEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<StaffProfile>;
};

export type StartDeviceCheckoutInput = {
  deviceId: Scalars['ID']['input'];
  personOrProfileId: Scalars['ID']['input'];
};

export type StartDeviceCheckoutPayload = {
  __typename?: 'StartDeviceCheckoutPayload';
  device: Device;
  deviceCheckout: DeviceCheckout;
};

export type StatisticsCategoricalDimension = StatisticsDimension & {
  __typename?: 'StatisticsCategoricalDimension';
  categories?: Maybe<Array<StatisticsCategoricalDimensionCategory>>;
  field: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type StatisticsCategoricalDimensionCategory = {
  __typename?: 'StatisticsCategoricalDimensionCategory';
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Node>;
};

export type StatisticsDateRangeDimension = StatisticsDimension & {
  __typename?: 'StatisticsDateRangeDimension';
  field: Scalars['String']['output'];
  from?: Maybe<Scalars['Date']['output']>;
  key: Scalars['String']['output'];
  to?: Maybe<Scalars['Date']['output']>;
};

export type StatisticsDimension = {
  field: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type StatisticsDimensionInput = {
  field: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  accessoryEventsCreated: SubscriptionAccessoryEvent;
  accountStatusUpdates: AccountStatusUpdatesSubscriptionPayload;
  countdown: Scalars['Int']['output'];
  dashboardKanbanEventsCreated: DashboardKanbanEvent;
  monitorEventsCreated: SubscriptionMonitorEvent;
};


export type SubscriptionAccessoryEventsCreatedArgs = {
  input: AccessoryEventsSubscriptionInput;
};


export type SubscriptionAccountStatusUpdatesArgs = {
  input: AccountStatusUpdatesSubscriptionInput;
};


export type SubscriptionCountdownArgs = {
  from: Scalars['Int']['input'];
};


export type SubscriptionDashboardKanbanEventsCreatedArgs = {
  accountId: Scalars['ID']['input'];
};


export type SubscriptionMonitorEventsCreatedArgs = {
  input: MonitorEventsSubscriptionInput;
};

export type SubscriptionAccessoryEvent = {
  __typename?: 'SubscriptionAccessoryEvent';
  accessory?: Maybe<Accessory>;
  account?: Maybe<Account>;
  createdAt: Scalars['DateTime']['output'];
  eventType: AccessoryEventType | '%future added value';
};

export type SubscriptionMonitorEvent = {
  __typename?: 'SubscriptionMonitorEvent';
  account?: Maybe<Account>;
  createdAt: Scalars['DateTime']['output'];
  eventType: MonitorEventType | '%future added value';
  monitor?: Maybe<Monitor>;
};

export type UpdateStaffInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStaffPayload = {
  __typename?: 'UpdateStaffPayload';
  staff: Staff;
};

export type UpdateStaffProfileInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
};

export type UpdateStaffProfilePayload = {
  __typename?: 'UpdateStaffProfilePayload';
  staffProfile: StaffProfile;
};

export type User = Node & {
  __typename?: 'User';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

type AccessoryStatusIndicatorAccessory_BridgeAccessory_Fragment = { __typename?: 'BridgeAccessory', operationStatus: AccessoryOperationalStatus };

type AccessoryStatusIndicatorAccessory_ButtonAccessory_Fragment = { __typename?: 'ButtonAccessory', operationStatus: AccessoryOperationalStatus };

type AccessoryStatusIndicatorAccessory_ClimateSensorAccessory_Fragment = { __typename?: 'ClimateSensorAccessory', operationStatus: AccessoryOperationalStatus };

type AccessoryStatusIndicatorAccessory_GenericAccessory_Fragment = { __typename?: 'GenericAccessory', operationStatus: AccessoryOperationalStatus };

export type AccessoryStatusIndicatorAccessoryFragment = AccessoryStatusIndicatorAccessory_BridgeAccessory_Fragment | AccessoryStatusIndicatorAccessory_ButtonAccessory_Fragment | AccessoryStatusIndicatorAccessory_ClimateSensorAccessory_Fragment | AccessoryStatusIndicatorAccessory_GenericAccessory_Fragment;

export type MonitorStatusIndicatorMonitorFragment = { __typename?: 'Monitor', operationStatus: MonitorOperationalStatus, charging?: boolean | null };

export type CurrentAccountFragment = { __typename?: 'Account', id: string, features: Array<string> };

export type FetchCurrentAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCurrentAccountQuery = { __typename?: 'Query', currentAccount?: { __typename?: 'Account', id: string, features: Array<string> } | null };

export type MonitorOptionFragment = { __typename?: 'Monitor', id: string, nickname?: string | null };

export type FetchMonitorOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchMonitorOptionsQuery = { __typename?: 'Query', monitorOptions: { __typename?: 'MonitorConnection', nodes: Array<{ __typename?: 'Monitor', id: string, nickname?: string | null }> } };

export type FetchMonitorOptionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FetchMonitorOptionQuery = { __typename?: 'Query', monitorOption?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null };

export type StatusScreenNestedLocationFragment = { __typename?: 'Location', id: string, name?: string | null };

export type StatusScreenNestedMonitorFragment = { __typename?: 'Monitor', id: string, nickname?: string | null };

export type StatusScreenMonitorFragment = { __typename: 'Monitor', id: string, nickname?: string | null, charging?: boolean | null, operational: boolean, operationStatus: MonitorOperationalStatus, location?: { __typename?: 'Location', id: string, name?: string | null } | null, sounds: Array<{ __typename?: 'Sound', slug?: string | null, name?: string | null, svg_icon_url?: string | null }>, observations: Array<{ __typename?: 'Observation', observation_type: string, sound?: { __typename?: 'Sound', slug?: string | null, name?: string | null, svg_icon_url?: string | null } | null }> };

type StatusScreenAccessory_BridgeAccessory_Fragment = { __typename: 'BridgeAccessory', id: string, nickname?: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, location?: { __typename?: 'Location', id: string, name?: string | null } | null, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null, parentAccessory?: { __typename?: 'BridgeAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ButtonAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ClimateSensorAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'GenericAccessory', id: string, operationStatus: AccessoryOperationalStatus } | null };

type StatusScreenAccessory_ButtonAccessory_Fragment = { __typename: 'ButtonAccessory', id: string, nickname?: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, gestureActions: Array<{ __typename?: 'AccessoryGestureAction', gesture: AccessoryGesture, action?: string | null }>, latestCall?: { __typename?: 'AidCall', startAt: string } | { __typename?: 'GenericCall', startAt: string } | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null, parentAccessory?: { __typename?: 'BridgeAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ButtonAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ClimateSensorAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'GenericAccessory', id: string, operationStatus: AccessoryOperationalStatus } | null };

type StatusScreenAccessory_ClimateSensorAccessory_Fragment = { __typename: 'ClimateSensorAccessory', id: string, nickname?: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, climate?: { __typename?: 'Climate', id: string, temperature?: number | null, alarms: Array<{ __typename?: 'ClimateAlarm', id: string, metric: ClimateAlarmMetric, currentStatus: ClimateAlarmCurrentStatus, disabled: boolean, thresholdType: ClimateAlarmThresholdType, alarmThreshold: number }> } | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null, parentAccessory?: { __typename?: 'BridgeAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ButtonAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ClimateSensorAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'GenericAccessory', id: string, operationStatus: AccessoryOperationalStatus } | null };

type StatusScreenAccessory_GenericAccessory_Fragment = { __typename: 'GenericAccessory', id: string, nickname?: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, location?: { __typename?: 'Location', id: string, name?: string | null } | null, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null, parentAccessory?: { __typename?: 'BridgeAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ButtonAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ClimateSensorAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'GenericAccessory', id: string, operationStatus: AccessoryOperationalStatus } | null };

export type StatusScreenAccessoryFragment = StatusScreenAccessory_BridgeAccessory_Fragment | StatusScreenAccessory_ButtonAccessory_Fragment | StatusScreenAccessory_ClimateSensorAccessory_Fragment | StatusScreenAccessory_GenericAccessory_Fragment;

export type FetchStatusScreenDataQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type FetchStatusScreenDataQuery = { __typename?: 'Query', account?: { __typename?: 'Account', dashboard?: { __typename?: 'DashboardAccount', connectedDevicesCount: number, averageResponseTime?: string | null, responseCount: number } | null, monitors: { __typename?: 'MonitorConnection', nodes: Array<{ __typename: 'Monitor', id: string, nickname?: string | null, charging?: boolean | null, operational: boolean, operationStatus: MonitorOperationalStatus, location?: { __typename?: 'Location', id: string, name?: string | null } | null, sounds: Array<{ __typename?: 'Sound', slug?: string | null, name?: string | null, svg_icon_url?: string | null }>, observations: Array<{ __typename?: 'Observation', observation_type: string, sound?: { __typename?: 'Sound', slug?: string | null, name?: string | null, svg_icon_url?: string | null } | null }> }> }, accessories: { __typename?: 'AccessoryConnection', nodes: Array<{ __typename: 'BridgeAccessory', id: string, nickname?: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, location?: { __typename?: 'Location', id: string, name?: string | null } | null, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null, parentAccessory?: { __typename?: 'BridgeAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ButtonAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ClimateSensorAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'GenericAccessory', id: string, operationStatus: AccessoryOperationalStatus } | null } | { __typename: 'ButtonAccessory', id: string, nickname?: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, gestureActions: Array<{ __typename?: 'AccessoryGestureAction', gesture: AccessoryGesture, action?: string | null }>, latestCall?: { __typename?: 'AidCall', startAt: string } | { __typename?: 'GenericCall', startAt: string } | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null, parentAccessory?: { __typename?: 'BridgeAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ButtonAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ClimateSensorAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'GenericAccessory', id: string, operationStatus: AccessoryOperationalStatus } | null } | { __typename: 'ClimateSensorAccessory', id: string, nickname?: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, climate?: { __typename?: 'Climate', id: string, temperature?: number | null, alarms: Array<{ __typename?: 'ClimateAlarm', id: string, metric: ClimateAlarmMetric, currentStatus: ClimateAlarmCurrentStatus, disabled: boolean, thresholdType: ClimateAlarmThresholdType, alarmThreshold: number }> } | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null, parentAccessory?: { __typename?: 'BridgeAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ButtonAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ClimateSensorAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'GenericAccessory', id: string, operationStatus: AccessoryOperationalStatus } | null } | { __typename: 'GenericAccessory', id: string, nickname?: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, location?: { __typename?: 'Location', id: string, name?: string | null } | null, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null, parentAccessory?: { __typename?: 'BridgeAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ButtonAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'ClimateSensorAccessory', id: string, operationStatus: AccessoryOperationalStatus } | { __typename?: 'GenericAccessory', id: string, operationStatus: AccessoryOperationalStatus } | null }> } } | null };

export type SubscribeStatusScreenMonitorDataSubscriptionVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type SubscribeStatusScreenMonitorDataSubscription = { __typename?: 'Subscription', monitorEventsCreated: { __typename?: 'SubscriptionMonitorEvent', monitor?: { __typename?: 'Monitor', id: string, charging?: boolean | null, operational: boolean, operationStatus: MonitorOperationalStatus } | null } };

export type SubscribeStatusScreenStatusUpdatesDataSubscriptionVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type SubscribeStatusScreenStatusUpdatesDataSubscription = { __typename?: 'Subscription', accountStatusUpdates: { __typename: 'AccountStatusUpdatesSubscriptionAccessoryPayload', accessoryId: string, operational: boolean, operationStatus: AccessoryOperationalStatus, accountId: string } | { __typename: 'AccountStatusUpdatesSubscriptionClimateAlarmPayload', climateAlarmId: string, currentStatus: ClimateAlarmCurrentStatus, accountId: string } | { __typename: 'AccountStatusUpdatesSubscriptionClimatePayload', temperature?: number | null, accountId: string, climateAccessoryId?: string | null } | { __typename: 'AccountStatusUpdatesSubscriptionMonitorPayload', monitorId: string, charging?: boolean | null, operational: boolean, accountId: string, monitorOperationStatus: MonitorOperationalStatus } };

export type FetchKanbanMonitorsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type FetchKanbanMonitorsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', monitors: { __typename?: 'MonitorConnection', nodes: Array<{ __typename?: 'Monitor', id: string, operational: boolean }> } } | null };

export type SubscribeKanbanMonitorsSubscriptionVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type SubscribeKanbanMonitorsSubscription = { __typename?: 'Subscription', monitorEventsCreated: { __typename?: 'SubscriptionMonitorEvent', monitor?: { __typename?: 'Monitor', id: string, operational: boolean } | null } };

export type KanbanEventMonitorFragment = { __typename?: 'Monitor', id: string, nickname?: string | null };

export type KanbanSoundEventFragment = { __typename?: 'DashboardKanbanSoundEvent', attendanceStatus: AttendanceStatus, createdAt: string, notificationImportance?: NotificationImportance | null, sound?: { __typename?: 'Sound', slug?: string | null, name?: string | null, svg_icon_url?: string | null } | null, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null };

export type KanbanAttendanceEventFragment = { __typename?: 'DashboardKanbanAttendanceEvent', createdAt: string, attendanceStatus: AttendanceStatus, isPhysicalAttendance: boolean, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null };

export type KanbanCallEventFragment = { __typename?: 'DashboardKanbanCallEvent', createdAt: string, attendanceStatus: AttendanceStatus, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null };

type KanbanEvent_DashboardKanbanAttendanceEvent_Fragment = { __typename: 'DashboardKanbanAttendanceEvent', createdAt: string, attendanceStatus: AttendanceStatus, isPhysicalAttendance: boolean, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null };

type KanbanEvent_DashboardKanbanCallEvent_Fragment = { __typename: 'DashboardKanbanCallEvent', createdAt: string, attendanceStatus: AttendanceStatus, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null };

type KanbanEvent_DashboardKanbanSoundEvent_Fragment = { __typename: 'DashboardKanbanSoundEvent', attendanceStatus: AttendanceStatus, createdAt: string, notificationImportance?: NotificationImportance | null, sound?: { __typename?: 'Sound', slug?: string | null, name?: string | null, svg_icon_url?: string | null } | null, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null };

export type KanbanEventFragment = KanbanEvent_DashboardKanbanAttendanceEvent_Fragment | KanbanEvent_DashboardKanbanCallEvent_Fragment | KanbanEvent_DashboardKanbanSoundEvent_Fragment;

export type FetchKanbanScreenEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchKanbanScreenEventsQuery = { __typename?: 'Query', currentAccount?: { __typename?: 'Account', dashboard?: { __typename?: 'DashboardAccount', kanban?: { __typename?: 'DashboardKanban', events: Array<{ __typename: 'DashboardKanbanAttendanceEvent', createdAt: string, attendanceStatus: AttendanceStatus, isPhysicalAttendance: boolean, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null } | { __typename: 'DashboardKanbanCallEvent', createdAt: string, attendanceStatus: AttendanceStatus, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null } | { __typename: 'DashboardKanbanSoundEvent', attendanceStatus: AttendanceStatus, createdAt: string, notificationImportance?: NotificationImportance | null, sound?: { __typename?: 'Sound', slug?: string | null, name?: string | null, svg_icon_url?: string | null } | null, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null }> } | null } | null } | null };

export type SubscribeKanbanScreenEventsSubscriptionVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type SubscribeKanbanScreenEventsSubscription = { __typename?: 'Subscription', dashboardKanbanEventsCreated: { __typename: 'DashboardKanbanAttendanceEvent', createdAt: string, attendanceStatus: AttendanceStatus, isPhysicalAttendance: boolean, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null } | { __typename: 'DashboardKanbanCallEvent', createdAt: string, attendanceStatus: AttendanceStatus, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null } | { __typename: 'DashboardKanbanSoundEvent', attendanceStatus: AttendanceStatus, createdAt: string, notificationImportance?: NotificationImportance | null, sound?: { __typename?: 'Sound', slug?: string | null, name?: string | null, svg_icon_url?: string | null } | null, monitor?: { __typename?: 'Monitor', id: string, nickname?: string | null } | null } };

type IStatisticsDimensionGroupBy_StatisticsCategoricalDimension_Fragment = { __typename: 'StatisticsCategoricalDimension', key: string };

type IStatisticsDimensionGroupBy_StatisticsDateRangeDimension_Fragment = { __typename: 'StatisticsDateRangeDimension', key: string };

export type IStatisticsDimensionGroupByFragment = IStatisticsDimensionGroupBy_StatisticsCategoricalDimension_Fragment | IStatisticsDimensionGroupBy_StatisticsDateRangeDimension_Fragment;

export type IStatisticsCategoricalDimensionCategoryFragment = { __typename?: 'StatisticsCategoricalDimensionCategory', label?: string | null };

type IStatisticsDimensionSortCategoryLabel_StatisticsCategoricalDimension_Fragment = { __typename?: 'StatisticsCategoricalDimension', categories?: Array<{ __typename?: 'StatisticsCategoricalDimensionCategory', label?: string | null }> | null };

type IStatisticsDimensionSortCategoryLabel_StatisticsDateRangeDimension_Fragment = { __typename?: 'StatisticsDateRangeDimension' };

export type IStatisticsDimensionSortCategoryLabelFragment = IStatisticsDimensionSortCategoryLabel_StatisticsCategoricalDimension_Fragment | IStatisticsDimensionSortCategoryLabel_StatisticsDateRangeDimension_Fragment;

export type FetchAcousticsScreenFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAcousticsScreenFilterOptionsQuery = { __typename?: 'Query', currentAccount?: { __typename?: 'Account', statisticsDimensions: Array<{ __typename: 'StatisticsCategoricalDimension', key: string, field: string, categories?: Array<{ __typename?: 'StatisticsCategoricalDimensionCategory', key: string, label?: string | null, node?: { __typename: 'BridgeAccessory' } | { __typename: 'ButtonAccessory' } | { __typename: 'Climate' } | { __typename: 'ClimateSensorAccessory' } | { __typename: 'Device' } | { __typename: 'GenericAccessory' } | { __typename: 'Monitor', routines: Array<{ __typename?: 'MonitorRoutine', active: boolean, startTime: string, endTime: string }> } | { __typename: 'Presence' } | { __typename: 'Sound' } | { __typename: 'User' } | null }> | null } | { __typename: 'StatisticsDateRangeDimension', from?: string | null, to?: string | null, key: string, field: string } | null> } | null };

export type FetchAidCallOverviewScreenFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAidCallOverviewScreenFilterOptionsQuery = { __typename?: 'Query', currentAccount?: { __typename?: 'Account', statisticsDimensions: Array<{ __typename: 'StatisticsCategoricalDimension', key: string, field: string, categories?: Array<{ __typename?: 'StatisticsCategoricalDimensionCategory', key: string, label?: string | null }> | null } | { __typename: 'StatisticsDateRangeDimension', from?: string | null, to?: string | null, key: string, field: string } | null> } | null };

export type FetchClimatesOverviewScreenClimatesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchClimatesOverviewScreenClimatesQuery = { __typename?: 'Query', account?: { __typename?: 'Account', climates: { __typename?: 'ClimateConnection', nodes: Array<{ __typename?: 'Climate', id: string, accessory?: { __typename?: 'BridgeAccessory', nickname?: string | null } | { __typename?: 'ButtonAccessory', nickname?: string | null } | { __typename?: 'ClimateSensorAccessory', nickname?: string | null } | { __typename?: 'GenericAccessory', nickname?: string | null } | null, alarms: Array<{ __typename?: 'ClimateAlarm', thresholdType: ClimateAlarmThresholdType, metric: ClimateAlarmMetric, alarmThreshold: number, disabled: boolean }> }> } } | null };

type FetchClimatesScreenClimateSensorAccessory_BridgeAccessory_Fragment = { __typename: 'BridgeAccessory', id: string, nickname?: string | null };

type FetchClimatesScreenClimateSensorAccessory_ButtonAccessory_Fragment = { __typename: 'ButtonAccessory', id: string, nickname?: string | null };

type FetchClimatesScreenClimateSensorAccessory_ClimateSensorAccessory_Fragment = { __typename: 'ClimateSensorAccessory', id: string, nickname?: string | null, climate?: { __typename?: 'Climate', id: string } | null };

type FetchClimatesScreenClimateSensorAccessory_GenericAccessory_Fragment = { __typename: 'GenericAccessory', id: string, nickname?: string | null };

export type FetchClimatesScreenClimateSensorAccessoryFragment = FetchClimatesScreenClimateSensorAccessory_BridgeAccessory_Fragment | FetchClimatesScreenClimateSensorAccessory_ButtonAccessory_Fragment | FetchClimatesScreenClimateSensorAccessory_ClimateSensorAccessory_Fragment | FetchClimatesScreenClimateSensorAccessory_GenericAccessory_Fragment;

export type FetchClimatesScreenClimateFragment = { __typename?: 'Climate', id: string, accessory?: { __typename?: 'BridgeAccessory', nickname?: string | null } | { __typename?: 'ButtonAccessory', nickname?: string | null } | { __typename?: 'ClimateSensorAccessory', nickname?: string | null } | { __typename?: 'GenericAccessory', nickname?: string | null } | null, alarms: Array<{ __typename?: 'ClimateAlarm', thresholdType: ClimateAlarmThresholdType, metric: ClimateAlarmMetric, alarmThreshold: number, disabled: boolean }> };

export type FetchClimatesScreenClimateQueryVariables = Exact<{
  climateId: Scalars['ID']['input'];
}>;


export type FetchClimatesScreenClimateQuery = { __typename?: 'Query', climate?: { __typename?: 'Climate', id: string, accessory?: { __typename?: 'BridgeAccessory', nickname?: string | null } | { __typename?: 'ButtonAccessory', nickname?: string | null } | { __typename?: 'ClimateSensorAccessory', nickname?: string | null } | { __typename?: 'GenericAccessory', nickname?: string | null } | null, alarms: Array<{ __typename?: 'ClimateAlarm', thresholdType: ClimateAlarmThresholdType, metric: ClimateAlarmMetric, alarmThreshold: number, disabled: boolean }> } | null };

export type FetchClimatesScreenFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchClimatesScreenFilterOptionsQuery = { __typename?: 'Query', currentAccount?: { __typename?: 'Account', statisticsDimensions: Array<{ __typename: 'StatisticsCategoricalDimension', key: string, field: string, categories?: Array<{ __typename?: 'StatisticsCategoricalDimensionCategory', key: string, label?: string | null }> | null } | { __typename: 'StatisticsDateRangeDimension', from?: string | null, to?: string | null, key: string, field: string } | null> } | null };

export const AccessoryStatusIndicatorAccessoryFragmentDoc = `
    fragment AccessoryStatusIndicatorAccessory on Accessory {
  operationStatus
}
    `;
export const MonitorStatusIndicatorMonitorFragmentDoc = `
    fragment MonitorStatusIndicatorMonitor on Monitor {
  operationStatus
  charging
}
    `;
export const CurrentAccountFragmentDoc = `
    fragment CurrentAccount on Account {
  id
  features
}
    `;
export const MonitorOptionFragmentDoc = `
    fragment MonitorOption on Monitor {
  id
  nickname
}
    `;
export const StatusScreenNestedLocationFragmentDoc = `
    fragment StatusScreenNestedLocation on Location {
  id
  name
}
    `;
export const StatusScreenMonitorFragmentDoc = `
    fragment StatusScreenMonitor on Monitor {
  __typename
  id
  nickname
  charging
  operational
  operationStatus
  location {
    ...StatusScreenNestedLocation
  }
  sounds: selectedSounds {
    slug
    name
    svg_icon_url: iconUrl(fileType: SVG)
  }
  observations: recentObservations {
    observation_type: observationType
    sound {
      slug
      name
      svg_icon_url: iconUrl(fileType: SVG)
    }
  }
}
    `;
export const StatusScreenNestedMonitorFragmentDoc = `
    fragment StatusScreenNestedMonitor on Monitor {
  id
  nickname
}
    `;
export const StatusScreenAccessoryFragmentDoc = `
    fragment StatusScreenAccessory on Accessory {
  __typename
  id
  nickname
  operational
  operationStatus
  location {
    ...StatusScreenNestedLocation
  }
  monitor {
    ...StatusScreenNestedMonitor
  }
  parentAccessory {
    id
    operationStatus
  }
  ... on ClimateSensorAccessory {
    climate {
      id
      temperature
      alarms {
        id
        metric
        currentStatus
        disabled
        metric
        thresholdType
        alarmThreshold
      }
    }
  }
  ... on ButtonAccessory {
    gestureActions {
      gesture
      action
    }
    latestCall {
      startAt
    }
  }
}
    `;
export const KanbanEventMonitorFragmentDoc = `
    fragment KanbanEventMonitor on Monitor {
  id
  nickname
}
    `;
export const KanbanSoundEventFragmentDoc = `
    fragment KanbanSoundEvent on DashboardKanbanSoundEvent {
  sound {
    slug
    svg_icon_url: iconUrl(fileType: SVG)
    name
  }
  monitor {
    ...KanbanEventMonitor
  }
  attendanceStatus
  createdAt
  notificationImportance
}
    `;
export const KanbanAttendanceEventFragmentDoc = `
    fragment KanbanAttendanceEvent on DashboardKanbanAttendanceEvent {
  monitor {
    ...KanbanEventMonitor
  }
  createdAt
  attendanceStatus
  isPhysicalAttendance
}
    `;
export const KanbanCallEventFragmentDoc = `
    fragment KanbanCallEvent on DashboardKanbanCallEvent {
  monitor {
    ...KanbanEventMonitor
  }
  createdAt
  attendanceStatus
}
    `;
export const KanbanEventFragmentDoc = `
    fragment KanbanEvent on DashboardKanbanEvent {
  __typename
  ...KanbanSoundEvent
  ...KanbanAttendanceEvent
  ...KanbanCallEvent
}
    `;
export const IStatisticsDimensionGroupByFragmentDoc = `
    fragment IStatisticsDimensionGroupBy on StatisticsDimension {
  __typename
  key
}
    `;
export const IStatisticsCategoricalDimensionCategoryFragmentDoc = `
    fragment IStatisticsCategoricalDimensionCategory on StatisticsCategoricalDimensionCategory {
  label
}
    `;
export const IStatisticsDimensionSortCategoryLabelFragmentDoc = `
    fragment IStatisticsDimensionSortCategoryLabel on StatisticsDimension {
  ... on StatisticsCategoricalDimension {
    categories {
      ...IStatisticsCategoricalDimensionCategory
    }
  }
}
    `;
export const FetchClimatesScreenClimateSensorAccessoryFragmentDoc = `
    fragment FetchClimatesScreenClimateSensorAccessory on Accessory {
  __typename
  id
  nickname
  ... on ClimateSensorAccessory {
    climate {
      id
    }
  }
}
    `;
export const FetchClimatesScreenClimateFragmentDoc = `
    fragment FetchClimatesScreenClimate on Climate {
  id
  accessory {
    nickname
  }
  alarms {
    thresholdType
    metric
    alarmThreshold
    disabled
  }
}
    `;
export const FetchCurrentAccountDocument = `
    query FetchCurrentAccount {
  currentAccount {
    ...CurrentAccount
  }
}
    ${CurrentAccountFragmentDoc}`;
export const FetchMonitorOptionsDocument = `
    query FetchMonitorOptions {
  monitorOptions: monitors {
    nodes {
      ...MonitorOption
    }
  }
}
    ${MonitorOptionFragmentDoc}`;
export const FetchMonitorOptionDocument = `
    query FetchMonitorOption($id: ID!) {
  monitorOption: monitor(id: $id) {
    ...MonitorOption
  }
}
    ${MonitorOptionFragmentDoc}`;
export const FetchStatusScreenDataDocument = `
    query FetchStatusScreenData($accountId: ID!) {
  account(id: $accountId) {
    dashboard {
      connectedDevicesCount
      averageResponseTime
      responseCount
    }
    monitors {
      nodes {
        ...StatusScreenMonitor
      }
    }
    accessories {
      nodes {
        ...StatusScreenAccessory
      }
    }
  }
}
    ${StatusScreenMonitorFragmentDoc}
${StatusScreenNestedLocationFragmentDoc}
${StatusScreenAccessoryFragmentDoc}
${StatusScreenNestedMonitorFragmentDoc}`;
export const SubscribeStatusScreenMonitorDataDocument = `
    subscription SubscribeStatusScreenMonitorData($accountId: ID!) {
  monitorEventsCreated(input: {accountId: $accountId}) {
    monitor {
      id
      charging
      operational
      operationStatus
    }
  }
}
    `;
export const SubscribeStatusScreenStatusUpdatesDataDocument = `
    subscription SubscribeStatusScreenStatusUpdatesData($accountId: ID!) {
  accountStatusUpdates(input: {accountId: $accountId}) {
    __typename
    accountId
    ... on AccountStatusUpdatesSubscriptionAccessoryPayload {
      accessoryId
      operational
      operationStatus
    }
    ... on AccountStatusUpdatesSubscriptionClimatePayload {
      climateAccessoryId: accessoryId
      temperature
    }
    ... on AccountStatusUpdatesSubscriptionClimateAlarmPayload {
      climateAlarmId
      currentStatus
    }
    ... on AccountStatusUpdatesSubscriptionMonitorPayload {
      monitorId
      charging
      operational
      monitorOperationStatus: operationStatus
    }
  }
}
    `;
export const FetchKanbanMonitorsDocument = `
    query FetchKanbanMonitors($accountId: ID!) {
  account(id: $accountId) {
    monitors {
      nodes {
        id
        operational
      }
    }
  }
}
    `;
export const SubscribeKanbanMonitorsDocument = `
    subscription SubscribeKanbanMonitors($accountId: ID!) {
  monitorEventsCreated(input: {accountId: $accountId}) {
    monitor {
      id
      operational
    }
  }
}
    `;
export const FetchKanbanScreenEventsDocument = `
    query FetchKanbanScreenEvents {
  currentAccount {
    dashboard {
      kanban {
        events {
          ...KanbanEvent
        }
      }
    }
  }
}
    ${KanbanEventFragmentDoc}
${KanbanSoundEventFragmentDoc}
${KanbanEventMonitorFragmentDoc}
${KanbanAttendanceEventFragmentDoc}
${KanbanCallEventFragmentDoc}`;
export const SubscribeKanbanScreenEventsDocument = `
    subscription SubscribeKanbanScreenEvents($accountId: ID!) {
  dashboardKanbanEventsCreated(accountId: $accountId) {
    ...KanbanEvent
  }
}
    ${KanbanEventFragmentDoc}
${KanbanSoundEventFragmentDoc}
${KanbanEventMonitorFragmentDoc}
${KanbanAttendanceEventFragmentDoc}
${KanbanCallEventFragmentDoc}`;
export const FetchAcousticsScreenFilterOptionsDocument = `
    query FetchAcousticsScreenFilterOptions {
  currentAccount {
    statisticsDimensions(
      measure: "events.count"
      dimensions: [{field: "date_time.", key: "datetime"}, {field: "monitor.id", key: "monitors"}]
    ) {
      __typename
      key
      field
      ... on StatisticsDateRangeDimension {
        from
        to
      }
      ... on StatisticsCategoricalDimension {
        categories {
          key
          label
          node {
            __typename
            ... on Monitor {
              routines {
                active
                startTime
                endTime
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const FetchAidCallOverviewScreenFilterOptionsDocument = `
    query FetchAidCallOverviewScreenFilterOptions {
  currentAccount {
    statisticsDimensions(
      measure: "aidcall.count"
      dimensions: [{field: "date_time.", key: "datetime"}, {field: "monitor.id", key: "monitors"}]
    ) {
      __typename
      key
      field
      ... on StatisticsDateRangeDimension {
        from
        to
      }
      ... on StatisticsCategoricalDimension {
        categories {
          key
          label
        }
      }
    }
  }
}
    `;
export const FetchClimatesOverviewScreenClimatesDocument = `
    query FetchClimatesOverviewScreenClimates {
  account: currentAccount {
    climates {
      nodes {
        ...FetchClimatesScreenClimate
      }
    }
  }
}
    ${FetchClimatesScreenClimateFragmentDoc}`;
export const FetchClimatesScreenClimateDocument = `
    query FetchClimatesScreenClimate($climateId: ID!) {
  climate(id: $climateId) {
    ...FetchClimatesScreenClimate
  }
}
    ${FetchClimatesScreenClimateFragmentDoc}`;
export const FetchClimatesScreenFilterOptionsDocument = `
    query FetchClimatesScreenFilterOptions {
  currentAccount {
    statisticsDimensions(
      measure: "temperature.avg"
      dimensions: [{field: "date_time.", key: "datetime"}, {field: "climate.id", key: "climates"}]
    ) {
      __typename
      key
      field
      ... on StatisticsDateRangeDimension {
        from
        to
      }
      ... on StatisticsCategoricalDimension {
        categories {
          key
          label
        }
      }
    }
  }
}
    `;

const injectedRtkApi = emptyGraphqlApi.injectEndpoints({
  endpoints: (build) => ({
    FetchCurrentAccount: build.query<FetchCurrentAccountQuery, FetchCurrentAccountQueryVariables | void>({
      query: (variables) => ({ document: FetchCurrentAccountDocument, variables })
    }),
    FetchMonitorOptions: build.query<FetchMonitorOptionsQuery, FetchMonitorOptionsQueryVariables | void>({
      query: (variables) => ({ document: FetchMonitorOptionsDocument, variables })
    }),
    FetchMonitorOption: build.query<FetchMonitorOptionQuery, FetchMonitorOptionQueryVariables>({
      query: (variables) => ({ document: FetchMonitorOptionDocument, variables })
    }),
    FetchStatusScreenData: build.query<FetchStatusScreenDataQuery, FetchStatusScreenDataQueryVariables>({
      query: (variables) => ({ document: FetchStatusScreenDataDocument, variables })
    }),
    FetchKanbanMonitors: build.query<FetchKanbanMonitorsQuery, FetchKanbanMonitorsQueryVariables>({
      query: (variables) => ({ document: FetchKanbanMonitorsDocument, variables })
    }),
    FetchKanbanScreenEvents: build.query<FetchKanbanScreenEventsQuery, FetchKanbanScreenEventsQueryVariables | void>({
      query: (variables) => ({ document: FetchKanbanScreenEventsDocument, variables })
    }),
    FetchAcousticsScreenFilterOptions: build.query<FetchAcousticsScreenFilterOptionsQuery, FetchAcousticsScreenFilterOptionsQueryVariables | void>({
      query: (variables) => ({ document: FetchAcousticsScreenFilterOptionsDocument, variables })
    }),
    FetchAidCallOverviewScreenFilterOptions: build.query<FetchAidCallOverviewScreenFilterOptionsQuery, FetchAidCallOverviewScreenFilterOptionsQueryVariables | void>({
      query: (variables) => ({ document: FetchAidCallOverviewScreenFilterOptionsDocument, variables })
    }),
    FetchClimatesOverviewScreenClimates: build.query<FetchClimatesOverviewScreenClimatesQuery, FetchClimatesOverviewScreenClimatesQueryVariables | void>({
      query: (variables) => ({ document: FetchClimatesOverviewScreenClimatesDocument, variables })
    }),
    FetchClimatesScreenClimate: build.query<FetchClimatesScreenClimateQuery, FetchClimatesScreenClimateQueryVariables>({
      query: (variables) => ({ document: FetchClimatesScreenClimateDocument, variables })
    }),
    FetchClimatesScreenFilterOptions: build.query<FetchClimatesScreenFilterOptionsQuery, FetchClimatesScreenFilterOptionsQueryVariables | void>({
      query: (variables) => ({ document: FetchClimatesScreenFilterOptionsDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useFetchCurrentAccountQuery, useLazyFetchCurrentAccountQuery, useFetchMonitorOptionsQuery, useLazyFetchMonitorOptionsQuery, useFetchMonitorOptionQuery, useLazyFetchMonitorOptionQuery, useFetchStatusScreenDataQuery, useLazyFetchStatusScreenDataQuery, useFetchKanbanMonitorsQuery, useLazyFetchKanbanMonitorsQuery, useFetchKanbanScreenEventsQuery, useLazyFetchKanbanScreenEventsQuery, useFetchAcousticsScreenFilterOptionsQuery, useLazyFetchAcousticsScreenFilterOptionsQuery, useFetchAidCallOverviewScreenFilterOptionsQuery, useLazyFetchAidCallOverviewScreenFilterOptionsQuery, useFetchClimatesOverviewScreenClimatesQuery, useLazyFetchClimatesOverviewScreenClimatesQuery, useFetchClimatesScreenClimateQuery, useLazyFetchClimatesScreenClimateQuery, useFetchClimatesScreenFilterOptionsQuery, useLazyFetchClimatesScreenFilterOptionsQuery } = injectedRtkApi;

